module.exports = __webpack_public_path__ + "static/media/fish-feeding.c03fba3f.jpg";